import styled, { keyframes } from 'styled-components';
import { toRem } from '../../ui';

const svgUrlX = 'url(\'data:image/svg+xml,<svg width="34" height="5" viewBox="0 0 34 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M-1.27856e-07 1.075C2.86 1.075 2.86 4 5.71 4C8.56 4 8.57 1 11.42 1C14.27 1 14.28 4 17.13 4C19.98 4 19.99 1 22.84 1C25.69 1 25.7 4 28.56 4C31.42 4 31.14 1.075 34 1.075" stroke="%23D2E1EC" stroke-width="1.5"/></svg>\')';
const svgUrlY = 'url(\'data:image/svg+xml,<svg width="5" height="34" viewBox="0 0 5 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.925 0C3.925 2.86 1 2.86 1 5.71C1 8.56 4 8.57 4 11.42C4 14.27 1 14.28 1 17.13C1 19.98 4 19.99 4 22.84C4 25.69 1 25.7 1 28.56C1 31.42 3.925 31.14 3.925 34" stroke-width="1.5" stroke="%23D2E1EC"/></svg>\')';

const animX = keyframes`
    from {
        background-position: 0 0;
    }
    to {
        background-position: 1000% 0;
    }
`;

const animY = keyframes`
    from {
        background-position: 0 0;
    }
    to {
        background-position: 0 10000%;
    }
`;

export const Wibble = styled.div<{ height?: any }>`
    background-image: ${svgUrlY};
    background-repeat: repeat-y;
    width: 0.375rem;
    height: ${p => toRem(p.height ?? '7.5')};

    &:hover {
        animation: ${animY} 20s linear infinite;
        animation-delay: .25s;
    }
`;

export const WibbleX = styled.div<{ width?: any }>`
    background-image: ${svgUrlX};
    background-repeat: repeat-x;
    width: ${p => toRem(p.width ?? '7.5')};
    height: 0.375rem;

    &:hover {
        animation: ${animX} 20s linear infinite;
        animation-delay: .25s;
    }
`;
